import React, { useEffect, useState } from 'react';
import AddressSearch from 'react-loqate';
import { Form } from "react-bootstrap"
import $ from "jquery/dist/jquery.min.js"


const AddressSearchInput = (props) => {

    function addresstype() {
        $("input[name=addressBuildingName]").val('');
    }


    return (
        <Form.Group className="text form-group">
            <div className="custom-float">
                <i className="icon-pin"></i>
                <input
                    name="in_address"
                    placeholder="Enter your address"
                    autocomplete="none"
                    type="text"
                    id="in_address"
                    className="form-control"
                    {...props}
                    value={props.addressLabel}
                    required="true"
                   // onKeyUp={addresstype()}
                />
                <input type="hidden" name="in_postcode" id="addressPostalCode" value='' />
                <input type="hidden" name="in_address_home" id="in_address_home" value='' />

                <input type="hidden" name="instant_stno" id="instant_stno" />
                <input type="hidden" name="instant_street" id="instant_street" />
                <input type="hidden" name="instant_district" id="instant_district" />
                <input type="hidden" name="instant_post_town" id="instant_post_town" />
                <input type="hidden" name="instant_county" id="instant_county" />
                <input type="hidden" name="instant_postcode" id="instant_postcode" />
                <input type="hidden" name="hometrack_add" id="hometrack_add" />

            </div>
        </Form.Group>
    );
};

export default function Addresssearch(props) {
    const selectAddressval = (address) => {
        
        var add_array = []
        if(address.Company) {
            add_array.push(address.Company)
        }
        if(address.Line1) {
            add_array.push(address.Line1)
        }
        if(address.Line2) {
            add_array.push(address.Line2)
        }
        if(address.Line3) {
            add_array.push(address.Line3)
        }
        if(address.Line4) {
            add_array.push(address.Line4)
        }
        if(address.City) {
            add_array.push(address.City)
        }
        if(address.PostalCode) {
            add_array.push(address.PostalCode)
        }
        var address_full = add_array.join(", ")

        var add_final = ''
        if(address.Line1) {
            add_final += address.Line1
        }
        if(address.Line2) {
            add_final += " "+address.Line2
        }
        if(address.Line3) {
            add_final += ", "+address.Line3
        }
        document.getElementById('in_address').value = address_full
        document.getElementById('instant_stno').value = (address.Line1).replace(/\n/g, ", ")
        var street_name = ((address.Line2 ? address.Line2 : '').replace(/\n/g, ", ") + (address.Line3 ? ','+address.Line3 : '').replace(/\n/g, ", ") + (address.Line4 ? ','+address.Line4 : '').replace(/\n/g, ", ") + (address.Line5 ? ','+address.Line5 : '').replace(/\n/g, ", "))
        document.getElementById('instant_street').value = street_name.replace(",,", ", ")
        document.getElementById('instant_district').value = (address.District).replace(/\n/g, ", ")
        document.getElementById('instant_post_town').value = (address.City).replace(/\n/g, ", ")
        document.getElementById('instant_county').value = (address.ProvinceName).replace(/\n/g, ", ")
        document.getElementById('instant_postcode').value = address.PostalCode
        document.getElementById('hometrack_add').value = add_final

        var address_text = ''
        if(address.BuildingNumber) {
            address_text += address.BuildingNumber+','
        }
        if(address.BuildingName) {
            address_text += address.BuildingName+','
        }
        if(address.SubBuilding) {
            address_text += address.SubBuilding+','
        }
        if(address.Street) {
            address_text += address.Street+','
        }
        if(address.City) {
            address_text += address.City
        }

        document.getElementById('in_address_home').value = address_text


        // document.getElementById('addressBuildingName').value = address.BuildingName
        // document.getElementById('addressBuildingNumber').value = address.BuildingNumber
        document.getElementById('addressPostalCode').value = address.PostalCode
        // document.getElementById('addressSubBuilding').value = address.SubBuilding
        // document.getElementById('addressStreet').value = address.Street

        // sessionStorage.setItem('addressBuildingName', address.BuildingName)
        // sessionStorage.setItem('addressBuildingNumber', address.BuildingNumber)
        // sessionStorage.setItem('addressPostalCode', address.PostalCode)
        // sessionStorage.setItem('addressSubBuilding', address.SubBuilding)
        // sessionStorage.setItem('addressStreet', address.Street)
    }

    return (
        <AddressSearch
            locale="en_GB"
            apiKey={process.env.GATSBY_LOQATE_API_KEY}
            countries={['GB']}
            id="in_address"
            components={{ Input: AddressSearchInput }}
            inputClassname="in_address form-control address-search"
            listClassname="address-options"
            listItemClassname="address-option"
            onSelect={address => selectAddressval(address)}

        />
    )
}
